import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import useEditData from "../../../hooks/useEditData";
import { NuDate, NuInput } from "../../../utils/Inputs";
import NuDateFormat from "../../../utils/NuDate";

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
}) {
  const { isEditLoading, editData } = useEditData();
  const [createNew, setCreateNew] = useState({
    name: "",
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    setCreateNew({
      name: data?.name,
      start_date: data?.start_date,
      end_date: data?.end_date,
    });
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      editData({
        url: `/Standards/${data.id}/dates`,
        value: value,
        resetForm: resetForm,
        onClose: onClose,
        getData: refreshData,
      });
    },
  });

  if (!visible) return null;
  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center  h-auto"
      >
        <div className="bg-white mt-12 p-2 h-auto rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative max-h-[calc(100vh-180px)] flex flex-wrap justify-between text-left">
            <NuInput
                  label="Standard Name"
                  disabled={data ? true : false}
                  name="name"
                  formik={formik}
                  placeholder="Standard Name"
                  width="w-full"
                />
                <NuDate
                 formik={formik}
                 label="Start Date"
                 name="start_date"
                 min={data?.last_reset_date?NuDateFormat({value:data.last_reset_date,format:"YYYY-MM-DD"}) :""}
                 width="w-full"
                />
                <NuDate
                 formik={formik}
                 label="End Date"
                 name="end_date"
                 min={formik.values.start_date}
                 width="w-full"
                />
              <div className=" w-full flex items-center justify-end px-3 py-6 rounded-b">
                <CancelButton onClose={resetClose} isLoading={isEditLoading} />
                <SubmitButton isLoading={isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
